import { axiosApi } from "../../../../../../../api/dbAxios";

export const deleteTeamComments = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  text: string | undefined,
  id: number,
) => {
  try {
    const response = await axiosApi.delete(
      `/items/${regulatorCode}/${case_no}/comments/${id}/`,
    );

    return response.data;
  } catch (error: any) {
    console.error("Error deleting Team Comments:", error);
    throw error.response.data[0];
  }
};
